__turbopack_context__.v({
  "applied": "apply-banner-module-scss-module__O0hOoq__applied",
  "apply": "apply-banner-module-scss-module__O0hOoq__apply",
  "apply-btn": "apply-banner-module-scss-module__O0hOoq__apply-btn",
});
